module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Chat-smile-e03fcd6d95c6bb92d3e89eb5cf70f2c3.svg";